


























































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import FileDrop from "@/components/common/FileDrop.vue";
import FileItem from "@/components/common/FileItem.vue";
import DropZone from "@/components/common/DropZone.vue";
import ChoiceMappingTables from "@/views/ChoiceImport/ChoiceMappingTables.vue"
import { API, Storage } from "aws-amplify";

import { Urls } from "@/Urls";
import { getModule } from "vuex-module-decorators";
import Decisions from "@/store/modules/Decisions";
import Modelling from "@/store/modules/Modelling";
import { create } from "domain";
import WorkspaceOptions from "@/store/modules/WorkspaceOptions";
import Choices from "@/store/modules/Choices";
import { Factor } from "@/api/model/FactorResource";
import _ from "lodash";
import { VIEWPOINT_API } from "@/api/ViewpointApi";

const decisionsModule = getModule(Decisions)
const modellingModule = getModule(Modelling)
const workspaceOptionsModule = getModule(WorkspaceOptions)
const choicesModule = getModule(Choices)

const papa = require('papaparse');

interface csvValue {
    column: number;
    name: string;    
}

@Component({
  components: { DropZone, FileItem, FileDrop, ChoiceMappingTables },
})



export default class ChoiceFileImporter extends Vue {
    @Prop({default: '', type: String})
    header!: string;

    @Prop({default: '', type: String})
    placeholder!: string;

    @Prop({default: '', type: String})
    hint!: string;

    @Prop({default: '', type: String})
    label!: string;

    @Prop({default: '', type: String})
    icon!: string;

    @Prop({default: '', type: String})
    btnText!: string;

    @Prop({default: false, type: Boolean})
    xSmall: boolean;

    @Prop({default: false, type: Boolean})
    small: boolean;

    @Prop({default: false, type: Boolean})
    large: boolean;

    @Prop({default: false, type: Boolean})
    xLarge: boolean;

    @Prop({default: false, type: Boolean})
    disabled!: boolean;

    private step = 1;
    private file: any = null;
    private name = '';
    private description = '';
    private uploadError = null;
    private uploading = false;
    private uploaded = false;
    private uploadProgressPercent: number | null = null
    private objectKey: string | null = null;
    private dialog = false;
    private API_NAME = "Viewpoint360API";
    private output = []
    private headers: String[] = [];
    private csvHeaders: csvValue[] = [];
    private map = {};
    private typeFactorMap = {};
    private loading = false;
    private increment = 0;
    private addToList = false;

    get selectedDecision() {
        return decisionsModule.selectedDecision;
    }

    get singularChoiceLabel() {
        return decisionsModule.singularChoiceLabel;
    }

    get activeChoiceLists() {
        return workspaceOptionsModule.activeChoiceLists
    }

    get pluralChoiceLabel() {
        return decisionsModule.pluralChoiceLabel;
    }

    private async fileSelected(files: any) {
        this.file = files[0];     
        try {
        this.uploadError = null;
        this.objectKey = await this.uploadFile(this.file);
        this.step++;
        await this.getHeadersFromFile(this.file);
        } catch (e) {
        console.log(e)
        this.uploadError = e
        }

        this.increment++;

    }

    private async uploadFile(file: any) {
        const key: string = `ingest/csv/${file.name}`;
        this.uploading = true;
        let uploadResponse: any = await Storage.put(key, file, {
        progressCallback: (progress: any) => {
            this.uploadProgressPercent = progress.loaded / progress.total
        }
        })
        this.uploading = false;
        this.uploaded = true;
        return uploadResponse.key;
    }

    private async getHeadersFromFile(file: File) {
        papa.parse(file, {
        complete: (results: any) => {
            this.headers = results.data[0]
            var i = 0

            results.data[0].forEach((value:string, index: number) => {
            let newHeader = {} as csvValue;
            newHeader.column = index;
            newHeader.name = (value) ? (value): `Column ${index}`;
            this.csvHeaders.push(newHeader)
            });
        }
        });
    }

    private async submit() {
        this.step = 3;
        this.loading = true;
        let selectedId = '';
        if(this.selectedDecision) {
        selectedId = this.selectedDecision.decisionId;
        } else {
            this.uploadError;
        }
        const path = `/ingest/decision/${selectedId}/choices`;
        const myInit = {
            body: {
                bucket: process.env.VUE_APP_STORAGE_S3_BUCKET,
                key: `public/${this.objectKey}`,
                name: this.name,
                description: this.description,
                // dataSourceId: '',
                choiceFactorMap: this.map,
                typeFactorMap: this.typeFactorMap
            }
        };

        try {
            let csvChoices = await VIEWPOINT_API.ingestChoices(selectedId, myInit);
            let createdChoices = [];
            // TEMPORARY FIX FOR BETA WHILE THE NEW CSV INGEST ISN'T ON IT YET - DELETE THIS CONDITION WHEN FIXED
            if(!window.location.hostname.includes('beta-app.viewpoint')) {
                if(csvChoices.length > 0 && csvChoices.length < 1000) {
                    await VIEWPOINT_API.createChoices(selectedId, csvChoices);
                } else if(csvChoices.length >= 1000) {
                    let numberOfBatches = Math.ceil(csvChoices.length / 1000)
                    for(let i = 0; i < numberOfBatches; i++) {
                        let result = await VIEWPOINT_API.createChoices(selectedId, csvChoices.slice(i * 1000 , (i+1) * 1000 ));
                        createdChoices.push(result);
                    }
                }
            } else {
                createdChoices = csvChoices
            }

            if(Object.values(this.typeFactorMap).includes("CATEGORICAL")) {
                await modellingModule.publishModel();
                for(let factor of Object.keys(this.typeFactorMap)) {
                    if(this.typeFactorMap[factor] === 'CATEGORICAL') {
                        let dataField = factor.toString().includes('_') ? factor.substring(0, factor.indexOf('_')) : factor
                        let categoryFactor =  Object.values(modellingModule.workingModelFactorResources).find((factor) => factor.dataField === dataField) as Factor
                        if(categoryFactor != null) {
                            let factorId = categoryFactor.id;
                            let publishedCategoryFactor = (modellingModule.publishedModelFactorResources[factorId] as Factor)
                            if(!_.isEqual(categoryFactor.valueTypeDefinition.categoricalValues, publishedCategoryFactor.valueTypeDefinition.categoricalValues)) {
                                categoryFactor.valueTypeDefinition = (modellingModule.publishedModelFactorResources[factorId] as Factor).valueTypeDefinition
                            }
                        } 
                      
                    }
                }
            }

            if(this.addToList) {
                for(let choice of createdChoices) {
                    decisionsModule.addChoiceToActiveLists(choice.id)
                }
            }

            this.loading = false;
            this.$emit('refreshChoices');

        } catch (err) {
            this.uploadError = err
        }
    }

    private back() {
        this.step--;
        if(this.step === 1) {
            this.csvHeaders = [];
            this.file = null;
            this.map = {};
            this.typeFactorMap = {};
            this.addIncrement()
        }

        if(this.step <= 0) {
            this.step = 1;
            this.dialog = false;
        }
    }

    private close() {
        this.dialog = false;
        this.step = 1;
        this.file = null;
        this.map = {};
        this.typeFactorMap = {};
        this.csvHeaders = [];
    }

    private mapHeaders(val: any, categoryVals: any) {
        this.map = val;
        this.typeFactorMap = categoryVals;
    }

    private addIncrement() {
        this.increment = ++this.increment
        this.file=null;
    }

    @Watch('dialog')
    private onChangeShowing(){
        this.increment = ++this.increment;
        this.file = null;
        this.step = 1;
    }

}
